import axios from "axios";
import {
  GET_ERRORS,
  SET_EMAIL_FOR_VERIFICATION,
  SET_ERROR,
  SIGNUP_FAILURE,
  SIGNUP_SUCCESS,
} from "./types";

export const signupUser = (userData) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/users/signup`,
      userData
    );
    dispatch({
      type: SIGNUP_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data,
    });
    dispatch({
      type: SIGNUP_FAILURE,
    });
    throw err;
  }
};
// Verify User
export const verifyUser =
  ({ email, code }) =>
  async (dispatch) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/users/verify`,
        { email, code }
      );
      dispatch({ type: "VERIFY_SUCCESS", payload: res.data });
      return res.data;
    } catch (err) {
      dispatch({ type: "VERIFY_FAILURE", payload: err?.response?.data });
      throw err;
    }
  };

// Resend Verification Code
export const resendVerificationCode =
  (email, successMessage) => async (dispatch) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/users/resend-verification`,
        null,
        { params: { email } }
      );
      dispatch({
        type: SET_ERROR,
        payload: { message: successMessage, type: "success" },
      });
    } catch (err) {
      dispatch({
        type: SET_ERROR,
        payload: {
          message: err?.response?.data?.message || "Failed to resend code",
          type: "error",
        },
      });
    }
  };

// Change Email (before verification)
export const changeEmailVerification =
  (oldEmail, newEmail) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/users/change-email-verification`,
      { oldEmail, newEmail }
    );
    dispatch({
      type: SET_EMAIL_FOR_VERIFICATION,
      payload: res?.data?.email || newEmail,
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};
